import styled from 'styled-components';
import Button from '../Button';

const ProductHeader = styled.header`
background:rgba(255, 255, 255, 0.78);
padding:5px 0px;
.logo{
  display: inline-block;
    margin-top: 5px;
    img{
      width:60%;
    }
}
ul{
  margin:0px;
  padding:0px;
  text-align: right;
  li{
  display: inline-block;
  margin-left: 20px;
  
  a{
  color: #626262;
  letter-spacing: 0px;
  padding:10px;
    font-size: 14px;
    display: block;
    border-bottom: rgba(255, 255, 255, 0.01) solid 2px;
  &:hover{
  text-decoration: none;
  border-bottom: ${({ theme }) => theme.primaryColor} solid 2px;
}
  &.active{
  border-bottom: ${({ theme }) => theme.primaryColor} solid 2px;
}
}
}
}
${Button} {
  border: none;
    background: ${({ theme }) => theme.lightRed};
    color: ${({ theme }) => theme.whiteColor};
    border-radius: 5px;
    margin: 0;
    margin-left: 5px;
    font-weight: normal;
    height: auto;
    padding: 10px 20px;
    font-size: 14px;
    &.white-btn{
      background: ${({ theme }) => theme.whiteColor};
      color:${({ theme }) => theme.lightRed};
      border:solid 1px ${({ theme }) => theme.lightRed};
    }
    }
`;

export default ProductHeader;



// WEBPACK FOOTER //
// client/components/ProductHeader/index.js